const reportWebVitals = (onPerfEntry?: any) => {
  // Web vitals reporting disabled for now
  console.log('Web vitals reporting disabled');
};

export default reportWebVitals;
